module.exports = __webpack_public_path__ + "img/20220219_130959.92eff749.jpg";